const _ = require('lodash')

const state = {
    mixParlay : 0,
    oddsFormatList : {
        a: {name: 'Hong Kong'},
        b: {name: 'Malay'},
        c: {name: 'Indo'},
        d: {name: 'Decimal'},
    },
    languagesList : {
        a: 'US',
        b: 'VN',
        c: 'TH',
    },

    language: 'US',
    translationLoaded: false,

    oddsFormatIndex: 'd',
    windowWidth: 0,
    windowHeight: 0,
    isMobile: false,

    trackingLinkId: 0,
    googleEventLabel: '',
    showLive: true,
    liveCount: 0,
    defaultSport: 'Soccer',
    baseSport: 'Soccer',
    trackingUrl: null,
    openedDate: 'today',
    openedSport: '',
    flickerMarket: null,
    maxMatchesCount: 0,
    focusName: '',
    focusMenuTitle: '',
    focusSport: '',
    focusOnLoad: '',
};

const mutations = {
    TRANSLATION_LOADED: (state) => {
        state.translationLoaded = true;
    },
    SET_MIX_PARLAY_TRUE: (state) => {
        state.mixParlay = 1;
    },
    SET_MIX_PARLAY_FALSE: (state) => {
        state.mixParlay = 0;
    },
    SET_ODDS_FORMAT_INDEX: (state, formatIndex) => {
        state.oddsFormatIndex = formatIndex;
    },
    SET_WINDOW_WIDTH: (state, windowWidth) => {
        state.isMobile = (windowWidth <= 800)
        state.windowWidth = windowWidth;
    },
    SET_WINDOW_HEIGHT: (state, windowHeight) => {
        state.windowHeight = windowHeight;
    },
    SET_TRACKING_URL: (state, trackingUrl) => {
        state.trackingUrl = trackingUrl;
    },
    SET_OPENED_DATE: (state, openedDate) => {
        state.openedDate = openedDate;
    },
    SET_OPENED_SPORT: (state, openedSport) => {
        state.openedSport = openedSport;
    },
    SET_FLICKER_MARKET: (state, market) => {
        state.flickerMarket = market;
    },
    SET_URL_PARAM: (state, param) => {
        if(param.value !== null){
            if(param.key === 'oddsFormat'){
                if(param.value  === "HK") { state.oddsFormatIndex = 'a' }
                else if(param.value  === "MY") { state.oddsFormatIndex = 'b' }
                else if(param.value  === "INDO") { state.oddsFormatIndex = 'c' }
                else { state.oddsFormatIndex = 'd' }
            }
            if(param.key === 'focusOnLoad' && param.value === true){
                state.openedDate = 'focusedTournament'
            }
            state[param.key] = param.value;
        }
    },
};

const actions = {
    translationLoaded({commit}) {
        return commit('TRANSLATION_LOADED')
    },
    setMixParlayTrue({commit}) {
        return commit('SET_MIX_PARLAY_TRUE')
    },
    setMixParlayFalse({commit}) {
        return commit('SET_MIX_PARLAY_FALSE')
    },
    setOddsFormat({commit}, formatIndex) {
        return commit('SET_ODDS_FORMAT_INDEX', formatIndex)
    },
    setWindowWidth({commit}, windowWidth) {
        return commit('SET_WINDOW_WIDTH', windowWidth)
    },
    setWindowHeight({commit}, windowHeight) {
        return commit('SET_WINDOW_HEIGHT', windowHeight)
    },
    setUrlParams({commit}, params) {
        _.forEach(params, (value, key) => {
            commit('SET_URL_PARAM', {key, value })
        })
    },
    setUrlParam({commit}, param) {
        commit('SET_URL_PARAM', param)
    },
    setTrackingUrl({commit}, trackingUrl) {
        commit('SET_TRACKING_URL', trackingUrl)
    },
    setOpenedDate({commit}, openedDate) {
        commit('SET_OPENED_DATE', openedDate)
    },
    setOpenedSport({commit}, openedSport) {
        commit('SET_OPENED_SPORT', openedSport)
    },
    setMarketClicked({commit}, market) {
        commit('SET_FLICKER_MARKET', market)
        setTimeout(() => commit('SET_FLICKER_MARKET', null), 1000);
    },
};

const getters = {
    focusOnLoad: state => state.focusOnLoad,
    openedDate: state => state.openedDate,
    mixParlay: state => state.mixParlay,
    oddsFormatList: state => state.oddsFormatList,
    oddsFormatIndex: state => state.oddsFormatIndex,
    oddsFormatCountry: state => state.oddsFormatList[state.oddsFormatIndex].name,
    windowWidth: state => state.windowWidth,
    windowHeight: state => state.windowHeight,
    isMobile: state => state.isMobile,
    paramsForServerSide: state => {
        return {
            trackingLinkId : state.trackingLinkId
        }
    },
    defaultSport: state => state.defaultSport,
    baseSport: state => state.baseSport,
    showLive: state => (state.openedDate === 'live')? true : state.showLive,
    liveCount: state => state.liveCount,
    language: state => state.language,
    trackingUrl: state => state.trackingUrl,
    googleEventLabel: state => state.googleEventLabel,
    flickerMarket: state => state.flickerMarket,
    maxMatchesCount: state => state.maxMatchesCount,
    translationLoaded: state => state.translationLoaded,

    focusName: state => (state.focusName !== '')? state.focusName : false,
    focusMenuTitle: state => (state.focusMenuTitle !== '')? state.focusMenuTitle : state.focusName,
    showOnOpenSport: state => state.focusSport === '' || state.focusSport === state.openedSport
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};